import {InstrumentComponent} from "./InstrumentComponent.js";
import {SurveyBarComponent} from "./SurveyBarComponent.js";
import {hide} from '@megaphonenpm/mputils/src/DOM.js';
import {notNil} from '@megaphonenpm/mputils/src/utils.js';

export class AnswersGuessGaugeComponent extends InstrumentComponent {
  constructor (themeID) {
    super(themeID, 'guessgauge', new SurveyBarComponent(themeID));
    this.indicator.setValueLabel(this.valueLabel);
    this.indicator.setPointerGap(this.getThemeSetting(`design.products.${this.instrumentName}.screen.valuepointer.gap.horizontal`, 0));
    hide(this.indicator.barFG, '.leadingBarContainer, .trailingBarContainer');
    this.indicator.view.style.alignSelf = 'initial';
    let indicatorColor = this.getThemeSetting('design.products.guessgauge.screen.indicator.color');
    if (notNil(indicatorColor)) {
      let defaultBar = this.indicator.barFG.querySelector('.defaultBar');
      if (defaultBar) {
        defaultBar.style.background = indicatorColor;
      } else {
        this.indicator.barFG.style.background = indicatorColor;
      }
    }

    let indicatorBackgroundColor = this.getThemeSetting('design.products.guessgauge.screen.indicator.background_color');
    if (notNil(indicatorBackgroundColor)) {
      this.indicator.barBG.style.background = indicatorBackgroundColor;
    }
  }
}




















